import React, { useState, useEffect } from "react";
import './pdf_enrollment.css';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";
import enrollmentService from '../../features/enrollment/enrollmentService';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';

function PDFEnrollment() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  console.log('queryParams', queryParams);
  // Retrieve specific query parameters  
  const districtId = queryParams.get('districtId');
  const authorization = queryParams.get('token');
  console.log('districtId', districtId);
  console.log('auth', authorization);

  const [enrollmentdata, setEnrollmentData] = useState([]);
  const [distName, setDistName] = useState('');
  let [isPageLoad, setisPageLoad] = useState(false);
  let [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    enrollmentService.getEnrollmentPageDatePDF({ districtId: districtId }, authorization).then((response) => {
      console.log("Enrollment Page Data : " + response.data);
      setDistName(response.data.distName)
      setEnrollmentData(response.data.enrollmentPageData);
      setIsLoading(false)
      setisPageLoad(true)

    }).catch(err => {
      toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
    })
  }, []);

  let enroldataFinal = [];
  const table_header = ["SURVEY TYPE", "SCHOOL NAME", "SCHOOL ID", "E-3", "E-4", "E-5", "E-6", "E-7", "E-8", "E-9", "E-10", "E-11", "E-12", "NT"];

  const TableRowStyledSurvyePdf = styled(TableRow)`
     &:nth-of-type(odd) {
       background-color: rgb(238, 238, 238);
     }
`;

  const getEnrollData = (shortCode, schoolId, enrollmentName) => {
    let surveyData = enrollmentdata.find((val, key) => {
      return val.shortCode == shortCode
    });

    if (surveyData) {
      let findSchool = surveyData.schoolEnrollData.find((val, key) => {
        return val.schoolId == schoolId
      });

      if (findSchool) {

        let findEnroll = findSchool.enrollmentData.find((val, key) => {
          return val.enrollmentName == enrollmentName
        });

        if (findEnroll) {
          return findEnroll.value ? findEnroll.value : '';
        } else {
          return ''
        }

      } else {
        return ''
      }
    } else {
      return ''
    }

  }

  const itemsPerPage = 20;
  const numPages = Math.ceil( enrollmentdata.length / itemsPerPage); //no of tables  
  console.log("numPages :" +numPages);

  return (
    <>
      <div className='pdfenrol_pageHeader'>
        <div id="pdfImage"><img alt="Delete School" src={require("../../assets/images/menuHeader.png")} className="pdfenrol_logoSize"></img></div>
        <div className="pdfenrol_ImageSub">CalSCHLS Coordinator Portal</div>
        <div className="pdfenrol_country">{distName}</div>
        <div className="pdfenrol_pgTitle">STUDENT ENROLLMENTS</div>
      </div>
      <div className='pdfenrol_pageContent'>
        <div className='pdfenrol_userTable'>
          <TableContainer>
            {Array.from({ length: numPages }).map((_, pageIndex) => (
               <Table>
               <TableHead className={itemsPerPage > 20 ? "page-break pdfreportmail_setHeaderbackground" : "pdfreportmail_setHeaderbackground"}>
                 <TableRow className="headerStyle">
                   {table_header.map((col) => (
                     <TableCell className="schoolHeaderEnrolPdf" key={col} sx={{ fontSize: '14px' }}>
                       {col}
                     </TableCell>
                   ))}
                 </TableRow>
               </TableHead>
               <TableBody >
                 {/* {enrollmentdata && enrollmentdata.map((data) => ( */}
                   {enrollmentdata.slice(pageIndex * itemsPerPage, (pageIndex + 1) * itemsPerPage).map((data, index) => (      
                   <React.Fragment>
                     {data.schoolEnrollData && data.schoolEnrollData.map((item, index) => (
                     <TableRowStyledSurvyePdf key={index}>
                         <TableCell className="schoolBodyEnrolPdf" ref={el => {
                                 if (el) {
                                   el.style.setProperty('width', '150px', 'important');
                                 }
                               }}>
                           {data.name}
                         </TableCell>
                         <TableCell className="schoolBodyEnrolPdf" ref={el => {
                                 if (el) {
                                   el.style.setProperty('width', '150px', 'important');
                                 }
                               }}>{item.name}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf" sx={{ width: '20px', textAlign: 'center' }}>{item.ncesId}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "3rd")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "4th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "5th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "6th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "7th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "8th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "9th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "10th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "11th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "12th")}</TableCell>
                         <TableCell className="schoolBodyEnrolPdf schoolBodyValueCenter" sx={{ width: '15px', textAlign: 'center' }}>{getEnrollData(data.shortCode, item.schoolId, "NT")}</TableCell>
                       </TableRowStyledSurvyePdf>
                     ))}
                   </React.Fragment>
                 ))}
               </TableBody>
             </Table>
            ))}
          </TableContainer>
        </div>
      </div>
      {isPageLoad ? <div id="pageload" ></div> : ''}
    </>
  )
}

export default PDFEnrollment